export default __webpack_public_path__ + "static/media/008-fossil.ed783c47.svg";